import * as React from 'react';
import {Typography} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import {Download} from '@mui/icons-material';
import CustomTable from '../../../shared/Table';
import {download} from '../../../utils/download';
import {getValueBySurvey} from '../helpers/mapping';
import {IPageProps} from '../index';

interface INumeroValutatoreProps {
    page: IPageProps | undefined,
    submissions: {
        uoa_id: number,
        uoa_name: string,
        uoa_custom_field_ente_proponente_51: string,
        totale_punteggi_pesati: number,
    }[];
}

const TotalScore = ({page, submissions}: INumeroValutatoreProps) => {
    const columns: string[] = [
        'Progetto',
        'Ente proponente',
        'Numero di Valutazioni',
        'Punteggio',
    ];

    const data: any = {};
    let rows: any;

    submissions.forEach(function (submission) {
        const score = Number(getValueBySurvey(page, submission, 'score'));

        if (data.hasOwnProperty(submission.uoa_id)) {
            data[submission.uoa_id].count = data[submission.uoa_id].count + 1;
            data[submission.uoa_id].sum = data[submission.uoa_id].sum + score;
        } else {
            data[submission.uoa_id] = {
                name: submission.uoa_name,
                field: submission.uoa_custom_field_ente_proponente_51,
                count: 1,
                sum: score
            };
        }
    })

    rows = Object.values(data)
        .map((item: any) => {
            return [
                item.name,
                item.field,
                item.count,
                Number.isFinite(item.sum) ? (item.sum / item.count).toFixed(2) : 0,
            ]
        })

    rows.sort(function (a: any, b: any) {
        return b[3] - a[3];
    });

    const handleDownload = () => {
        download([columns, ...rows], 'Total score progetti')
    }

    return (
        <>
            <div className='content-title'>
                <Typography variant='h5'>
                    Total score progetti
                </Typography>
                <IconButton onClick={handleDownload}>
                    <Download fontSize='small'/>
                </IconButton>
            </div>
            <CustomTable
                columns={columns}
                rows={rows}
                numberRows={[1, 2]}/>
        </>
    );
};

export default TotalScore;
